import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { SensitiveCitiesFormSchema } from 'src/models/sensitive-cities.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const SensitiveCitiesForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={SensitiveCitiesFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="2">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_SENSITIVE_CITY}
                    name="sensitiveCity"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.sensitiveCity}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_SENSITIVE_CITY_PAM_LEAD}
                    name="pamLead"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.pamLead}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="sensitiveCityId"
                    control={control}
                    error={errors.sensitiveCityId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default SensitiveCitiesForm;
